'use client';
import React from 'react';

import { ArrowRight } from '@/app/assets/Icons';
import {
	cn,
	Pagination,
	PaginationItemRenderProps,
	PaginationItemType,
	PaginationProps,
} from '@nextui-org/react';

interface IProps extends PaginationProps {}

const IPagination: React.FC<IProps> = (props) => {
	const renderItem = ({
		ref,
		key,
		value,
		isActive,
		isLast,
		onNext,
		setPage,
		className,
	}: PaginationItemRenderProps) => {
		if (value === PaginationItemType.NEXT) {
			return (
				<button
					key={key}
					className={cn(className, 'size-10')}
					disabled={isLast}
					onClick={onNext}
				>
					<ArrowRight className="text-bittersweet size-6" />
				</button>
			);
		}

		if (value === PaginationItemType.PREV) {
			return (
				<button key={key} className={cn(className, 'hidden')}></button>
			);
		}

		if (value === PaginationItemType.DOTS) {
			return (
				<button
					key={key}
					className={cn(className, 'text-gray font-semibold')}
				>
					...
				</button>
			);
		}

		// cursor is the default item
		return (
			<button
				key={key}
				ref={ref}
				className={cn(
					className,
					'text-gray size-10 overflow-hidden rounded-lg text-base font-semibold',
					isActive && 'bg-mauvelous text-bittersweet'
				)}
				onClick={() => setPage(value)}
			>
				{value}
			</button>
		);
	};
	return (
		<Pagination
			showControls
			page={props.page}
			total={props.total}
			initialPage={props.initialPage}
			onChange={props.onChange}
			renderItem={renderItem}
			classNames={{
				base: 'p-0 m-0',
				wrapper: 'gap-6',
				prev: 'hidden',
			}}
		/>
	);
};

export default IPagination;
